<template>

  <div class="ob-content">

    <loader :condition="dataLoaded">
      <toolbar>
        <template v-slot:head>
          <asset-path :item="item" :model="model.name" clickable-nodes />
        </template>

        <template v-slot:controls>
          <v-btn color="primary" v-if="!readonly" @click="saveAsset()">{{ $t('save') }}</v-btn>
          <v-btn @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
          <v-btn @click="$router.push({ name: 'logs', query: { assets: item.id } })">{{ $t('assets.logs') }}</v-btn>

          <v-menu bottom origin="center center" v-if="item.visuals && item.visuals.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                {{ $t('assets.visuals') }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(visual, i) in item.visuals" :key="i" @click="">
                <v-list-item-title @click="$router.push({ name: 'visuals/id', params: { id: visual.id, initVisualMode: 'watch' } })">{{ visual.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn color="error" v-if="!readonly" @click="onDestroy(item)">{{ $t('archive') }}</v-btn>
        </template>
      </toolbar>

      <div class="ob-grid">
        <asset-form class="ob-col-12" :asset="item" :readonly="readonly"></asset-form>

        <asset-device-config class="ob-col-12" :asset="item" :readonly="readonly" @change="variablesChanged = true"></asset-device-config>

        <v-card class="ob-col-12">
          <toolbar medium>
            <template v-slot:head>
              {{ $tc('issues.entity-name', 2) }}
            </template>

            <template v-slot:controls>
              <v-btn depressed small color="primary" @click="$router.push({ name: 'issues/new', params: { newItem: { assetId: item.id, maintenance: false } } })">
                <v-icon>add</v-icon> {{ $t('issues.new') }}
              </v-btn>
            </template>
          </toolbar>

          <issues-table :source="sources.issues" hidden="assets" @click="$router.push({ name: 'issues/id', params: { id: $event.id} })"></issues-table>
        </v-card>

        <div class="ob-col-12" v-if="monitoring">
          <toolbar medium>
            <template v-slot:head>
              {{ $t('assets.monitoring.title') }}
            </template>
          </toolbar>

          <condition-monitoring :asset="item"></condition-monitoring>
        </div>

        <v-card class="ob-col-6">
          <toolbar medium>
            <template v-slot:head>
              {{ $t('assets.sub-assets') }}
            </template>
          </toolbar>

          <assets-table :source="sources.subassets" @click="$router.push({ name: 'assets/id', params: { id: $event.id} })"></assets-table>
        </v-card>

        <v-card class="ob-col-6">
          <asset-files :asset="item"></asset-files>
        </v-card>
      </div>
    </loader>

  </div>

</template>

<script>
import itemHelpers from '../helpers/item-helpers.es6'
import Toolbar from '../shared/toolbar'
import Loader from '../shared/loader'
import AssetForm from './components/asset-form'
import IssuesTable from '../issues/components/issues-table'
import AssetsTable from './components/assets-table'
import ApiService from '../../services/api.service.es6'
import AssetFiles from './components/asset-files'
import ConditionMonitoring from './components/monitoring/monitoring'
import AssetPath from '../shared/components/tree-path'
import AssetDeviceConfig from './components/asset-device-config'

export default {

  mixins: [ itemHelpers ],

  data: function () {
    return {
      model: { name: 'assets' },
      sources: {
        issues: () => this.item.issues,
        subassets: args => ApiService.findAllPaginated('assets', { parentId: this.item.id }, args.sort, args.pagination)
      },
      variablesChanged: false
    }
  },

  computed: {
    readonly () {
      return !this.$can('manager')
    },

    monitoring () {
      return this.item && this.item.monitoringConfig && !!Object.keys(this.item.monitoringConfig).length
    }
  },

  methods: {
    async saveAsset(silent) {
      await this.save({reRoute: !silent, snackbar: !silent, saveitem: !silent})

      if (this.variablesChanged)
        this.$store.commit('clearLogsCache', this.item.id)

      this.$store.dispatch('refreshStaticItems', {model: {name: this.model.name, tree: true}})
    }
  },

  components: {
    AssetDeviceConfig,
    AssetPath,
    ConditionMonitoring,
    AssetFiles,
    AssetsTable,
    IssuesTable,
    AssetForm,
    Loader,
    Toolbar
  }
}
</script>

<style scoped lang="scss">

</style>
